import React from 'react'

const Book = () => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill="#3F5063" d="M23.2,55c-0.6,0-1.1-0.5-1.1-1.1v-40c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v40
	C24.3,54.5,23.8,55,23.2,55z"/>
      <path fill="#6EC18A" d="M48.9,55H18.2c-1.8,0-3.2-1.5-3.2-3.2V16.1c0-1.8,1.5-3.2,3.2-3.2h15c0.6,0,1.1,0.5,1.1,1.1
	c0,0.6-0.5,1.1-1.1,1.1h-15c-0.6,0-1,0.5-1,1v35.7c0,0.6,0.5,1,1,1h29.6V15h-4.6c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h5.7
	c0.6,0,1.1,0.5,1.1,1.1v40C50,54.5,49.5,55,48.9,55z"/>
      <path fill="#3F5063" d="M43.2,29.3c-0.2,0-0.4,0-0.5-0.1l-4.4-2.5l-4.5,2.5c-0.3,0.2-0.8,0.2-1.1,0c-0.3-0.2-0.5-0.6-0.5-0.9V11.1
	c0-0.6,0.5-1.1,1.1-1.1h10c0.6,0,1.1,0.5,1.1,1.1v17.1c0,0.4-0.2,0.8-0.5,0.9C43.6,29.3,43.4,29.3,43.2,29.3z M34.3,12.2v14.2
	l3.4-1.9c0.3-0.2,0.8-0.2,1.1,0l3.3,1.9V12.2H34.3z"/>
    </svg>
  )
}

export default Book
